var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsExpandOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 5.33334V2.66667M2.66675 2.66667H5.33341M2.66675 2.66667L6.00008 6.00001M13.3334 5.33334V2.66667M13.3334 2.66667H10.6667M13.3334 2.66667L10.0001 6.00001M2.66675 10.6667V13.3333M2.66675 13.3333H5.33341M2.66675 13.3333L6.00008 10M13.3334 13.3333L10.0001 10M13.3334 13.3333V10.6667M13.3334 13.3333H10.6667",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsExpandOutline);
export default __webpack_public_path__ + "static/media/ArrowsExpandOutline.df37006bea0e6b9c9aab8674e74c891a.svg";
export { ForwardRef as ReactComponent };